import React, { useState, useEffect } from "react";
import CallIcon from "@mui/icons-material/Call";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import "./EditPetProfileDesktopView.css";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import axios from "axios";

function EditPetProfileDesktopView() {
  const [isEdit, setIsEdit] = useState(false);
  const [orderSummary, setOrderSummary] = useState({});
  const [petTypeResponse, setPetTypeResponse] = useState([]);
  const [petBreedResponse, setPetBreedResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;

  const handlePetProfileEditMode = () => {
    setIsEdit(true);
  };

  const CancelEditMode = () => {
    setIsEdit(false);
  };
  const email = JSON.parse(localStorage.getItem("email"));

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(`${baseAPI}customerget/GetCustomerPetProfile?Email=` + email, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response.data?.data?.length > 0) {
            setOrderSummary(response.data.data[0]);
            setFirstItem(response.data.data[0]);

            getPetType();
            getPetBreed(response.data.data[0]?.pet_type);
          } else {
            console.warn("No data found in response");
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
          if (error.response) {
            console.error("Response Data:", error.response.data);
            console.error("Response Status:", error.response.status);
            console.error("Response Headers:", error.response.headers);
          }
        });
    } else {
      console.error("No token found, redirect to login or show error");
    }
  }, []);

  const [firstItem, setFirstItem] = useState({
    CustomerID: "",
    pet_type: "",
    pet_name: "",
    pet_breed: "",
    pet_gender: "",
    pet_dob: "",
    pet_color: "",
    pet_behaviour: "",
    Email: "",
  });

  const saveDetails = async (e) => {
    e.preventDefault();

    setFirstItem((prev) => ({
      ...prev,
      Email: email,
    }));

    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerPetProfile`,
        {
          ...firstItem,
          Email: email,
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      window.location.reload();
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  function getPetType() {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GEPetType?PetType=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setPetTypeResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const handleSelectChangePetType = (event) => {
    firstItem.pet_type = event.target.value;
    getPetBreed(event.target.value);
  };

  function getPetBreed(pet_type) {
    if (pet_type === null || pet_type === "") {
      pet_type = 0;
    }

    const storedToken = JSON.parse(localStorage.getItem("accessToken"));
    axios
      .get(
        `${baseAPI}adminget/GEPetBreedType?PetBreedID=0&PetType=` + pet_type,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setPetBreedResponse(response.data.data);
      });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  return (
    <div>
      <div className="customer-edit-main px-5 py-5">
        <div className="row container-fluid p-0">
          <div className="col-7 p-0 customer-edit-img-div d-flex justify-content-start align-items-center">
            <div className="customer-icon">
              <PersonOutlineIcon className="" />
            </div>
            <div className="customer-edit-img-div-content">
              <h5>{orderSummary.pet_name ? orderSummary.pet_name : ""}</h5>
              <h6>{orderSummary.petBreedName}</h6>
            </div>
          </div>
          {isEdit ? null : (
            <div className="col-5 d-flex justify-content-end align-items-start">
              <div className="customer-profile-edit-button-div">
                <button
                  onClick={handlePetProfileEditMode}
                  style={{ fontSize: "16px" }}
                  type=""
                  className="btn px-4"
                >
                  Edit
                </button>
              </div>
            </div>
          )}
        </div>
        {isEdit ? (
          <form className="relocation-details-main-form">
            <div className="form-row row align-items-center">
              <div className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Pet Type
                </label>
                <select
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  className="form-select m-0"
                  name="pet_type"
                  onChange={handleSelectChangePetType}
                  value={firstItem.pet_type}
                  onClick={getPetType}
                >
                  <option value="0" style={{ width: "5rem" }}>
                    Select an option
                  </option>
                  {petTypeResponse.map((item) => (
                    <option value={item.id}>{item.petType}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Name
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="pet_name"
                  value={firstItem.pet_name}
                  onChange={handleChange}
                />
              </div>
              <div style={{ position: "relative" }} className="col-md-4 col-12">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Breed
                </label>
                <select
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  className="form-select m-0"
                  name="pet_breed"
                  value={firstItem.pet_breed}
                  onChange={handleChange}
                >
                  <option value="0">Select an option</option>
                  {petBreedResponse.map((item) => (
                    <option value={item.id}>{item.PetBreedType}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-row row align-items-center">
              <div style={{ position: "relative" }} className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Gender
                </label>
                <select
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  className="form-select m-0"
                  name="pet_gender"
                  value={firstItem.pet_gender}
                  onChange={handleChange}
                >
                  <option value="">Select an option</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                </select>
              </div>
              <div style={{ position: "relative" }} className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Date Of Birth
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: isEdit ? "29px" : "27px",
                    paddingTop: isEdit ? "0px" : "",
                    width: "100%",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="pet_dob"
                  onChange={handleChange}
                  value={
                    firstItem.pet_dob
                      ? new Date(firstItem.pet_dob).toLocaleDateString("en-CA")
                      : ""
                  }
                />
              </div>
              <div className="col-md-4 col-12">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Colour
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="pet_color"
                  value={firstItem.pet_color}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row row align-items-center">
              <div className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Behaviour
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",
                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  type="text"
                  placeholder="Enter"
                  className="form-control m-0"
                  name="pet_behaviour"
                  value={firstItem.pet_behaviour}
                  onChange={handleChange}
                />
              </div>
            </div>

            <hr style={{ marginTop: "46px" }} />
            <div
              style={{ textAlign: "start" }}
              className="customer-profile-bottom-button-div mt-4"
            >
              <button
                style={{
                  color: "white",
                  fontSize: "16px",
                  backgroundColor: "#5B489D",
                }}
                type="submit"
                className="btn customer-profile-save-btn"
                onClick={saveDetails}
              >
                Save
              </button>
              <button
                onClick={CancelEditMode}
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#F15843",
                  border: "none",
                }}
                type=""
                className="btn customer-profile-cancel-btn"
              >
                Cancel
              </button>
            </div>
          </form>
        ) : (
          <div className="relocation-details-main-form">
            <div className="form-row row align-items-start">
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "29px",
                  }}
                >
                  Pet Type
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.petTypeName}
                </h4>
              </div>
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "29px",
                  }}
                >
                  Name
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {" "}
                  {orderSummary.pet_name}
                </h4>
              </div>
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "29px",
                  }}
                >
                  Breed
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.petBreedName}
                </h4>
              </div>
            </div>

            <div className="form-row row align-items-start">
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "29px",
                  }}
                >
                  Gender
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.pet_gender === "1" ? "Male" : "Female"}
                </h4>
              </div>
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "29px",
                  }}
                >
                  Date Of Birth
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {new Date(orderSummary.pet_dob).toLocaleString("en-US", {
                    month: "short", // Oct
                    day: "numeric", // 23
                    year: "numeric", // 2024
                    hour: "numeric", // 11
                    minute: "numeric", // 22
                    hour12: true, // AM/PM format
                  })}
                </h4>
              </div>
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "29px",
                  }}
                >
                  Colour
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                    paddingRight: "20px",
                  }}
                >
                  {" "}
                  {orderSummary.pet_color}
                </h4>
              </div>
            </div>

            <div className="form-row row align-items-start">
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "29px",
                    paddingLeft: "2px",
                  }}
                >
                  Behaviour
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.pet_behaviour}
                </h4>
              </div>
            </div>
          </div>
        )}
      </div>
      {isEdit ? null : (
        <div className="container customer-edit-main pet-add-pet-main mt-4 p-4">
          <div className="pet-add-pet-content p-4 w-100">
            <div className="add-pet-content">
              <AddCircleOutlineIcon className="add-pet-icon" />
              <h5>Add Pet</h5>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EditPetProfileDesktopView;
